import { render, staticRenderFns } from "./translateApproveEdit.vue?vue&type=template&id=4732a554&scoped=true"
import script from "./translateApproveEdit.vue?vue&type=script&lang=js"
export * from "./translateApproveEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4732a554",
  null
  
)

export default component.exports